module.exports = __webpack_public_path__ + "img/greenlife1.3126a927.svg";